import { useEffect, useState } from 'react'

import { getCountdown } from 'views/components/organisms/NowCountdown/helpers'

const NowCountdown = () => {
  const [countdown, setCountdown] = useState(getCountdown())

  useEffect(() => {
    window?.setInterval(() => {
      setCountdown(getCountdown())
    }, 1000)
  }, [])

  return <strong>{countdown}</strong>
}
export default NowCountdown
